import type { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { faCog, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import type { RowProps } from 'react-bootstrap';
import { Button, Card, Col, ProgressBar, Row } from 'react-bootstrap';

export type StatsCardProps = {
  onClick?: () => void;
  loading: boolean;
  number: number;
  title: string;
  icon: IconDefinition;
  variant: string;
  progressBar?: boolean;
};

export const StatsCard = ({
  onClick,
  loading,
  icon,
  number,
  title,
  variant,
  progressBar = true,
}: StatsCardProps) => {
  return (
    <Card
      role="button"
      className={`border bg-white h-100 hover-border-${variant} hover-shadow-inset`}
      onClick={onClick}
    >
      <Card.Body className="px-3">
        <h6 className="fw-bold mt-0 mb-0">{title}</h6>
        <Row className="my-4">
          <Col xs={6}>
            <FontAwesomeIcon widthAuto className={`text-${variant}`} size="3x" icon={icon} />
          </Col>
          <Col xs={6} className="text-end">
            {loading ? (
              <FontAwesomeIcon size="3x" icon={faSpinner} spin />
            ) : (
              <p className="h2 fw-bold">{number}</p>
            )}
          </Col>
        </Row>
        {progressBar && <ProgressBar className="progress-bar-sm" variant={variant} now={75} />}
      </Card.Body>
    </Card>
  );
};

type SkeletonGroupProps = RowProps & {
  items: number;
};

export const StatsCardSkeletonGroup = ({ items, ...rest }: SkeletonGroupProps) => {
  return (
    <Row xs={items} {...rest}>
      {Array.from({ length: items }).map((_, index) => (
        <Col key={index}>
          <StatsCardSkeleton key={index} />
        </Col>
      ))}
    </Row>
  );
};

export const StatsCardSkeleton = () => {
  return (
    <Card className={`border bg-white h-100 hover-shadow-inset`}>
      <Card.Body className="px-3">
        <div className="d-flex align-items-center">
          <div className="px-2 me-3 text-center">
            <span
              className="placeholder rounded-circle d-inline-block"
              style={{ width: 40, height: 40 }}
            />
          </div>
          <div className="flex-grow-1">
            <div className="placeholder-glow mb-1">
              <span className="placeholder col-8" />
            </div>
            <div className="placeholder-glow mb-1">
              <span className="placeholder col-4" />
            </div>
            <div className="placeholder-glow mb-1">
              <span className="placeholder col-6" />
            </div>
            <div className="placeholder-glow mb-1">
              <span className="placeholder col-9" />
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};
